export type NameType = 'done';

export const name: NameType = 'done';
